import { dayjs } from "../../../lib";
import { getCssVar } from "../../../utils";
import { t } from "i18next";
import { downloadComponentAsImage } from "../../LineCharts/helpers/helper";
import { clear, lineX, saveImage } from "../icons";

export const toolboxAndTooltipConfig = (
  isZoomActive: boolean,
  isFlaring?: boolean,
  printRef?: React.RefObject<HTMLDivElement>
) => ({
  brush: { toolbox: ["lineX", "clear"], xAxisIndex: 0 },
  tooltip: {
    animation: false,
    trigger: "axis",
    confine: true,
    backgroundColor: getCssVar("--gray-4"),
    borderColor: getCssVar("--gray-4"),
    textStyle: {
      color: getCssVar("--gray-7"),
      fontSize: 12,
    },

    axisPointer: {
      label: {
        formatter(params: { value: string }) {
          const defaultTooltipDateTime = isFlaring
            ? t("formats:date.datetime_minute_second")
            : t("formats:date.datetime_minute");

          return dayjs(params.value).format(defaultTooltipDateTime);
        },
      },
    },
  },
  toolbox: {
    show: true,
    top: 10,
    left: 0,
    feature: {
      brush: {
        title: {
          lineX: "Zoom",
          clear: "Reset",
        },

        icon: {
          lineX,
          clear: isZoomActive ? clear : undefined,
        },
      },

      myTool: {
        title: "Save as image",

        icon: saveImage,
        onclick: () => {
          downloadComponentAsImage(printRef);
        },
      },
    },
  },
});
export const defaultGridConfig = (
  yAxisLength: number,
  axisLabelDefaultFormat: string,
  interval?: Date[]
) => {
  return {
    grid: {
      animation: false,
      left: 25,
      right: yAxisLength * 20,

      top: 50,
      bottom: 20,
      containLabel: true,
    },
    xAxis: {
      type: "time",
      axisLabel: {
        formatter: axisLabelDefaultFormat,
        hideOverlap: true,
        showMinLabel: true,
        showMaxLabel: true,
        color: getCssVar("--gray-300"),
        customValues: interval,
      },

      animation: false,
      boundaryGap: true,
      axisLine: {
        show: true,
        lineStyle: { color: getCssVar("--gray-700"), width: 1.5 },
      },
      splitLine: { show: true, lineStyle: { color: getCssVar("--gray-700") } },
    },
  };
};
